import { render, staticRenderFns } from "./register.vue?vue&type=template&id=74af8ea3&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=74af8ea3&lang=scss"
import style1 from "./register.vue?vue&type=style&index=1&id=74af8ea3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74af8ea3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74af8ea3')) {
      api.createRecord('74af8ea3', component.options)
    } else {
      api.reload('74af8ea3', component.options)
    }
    module.hot.accept("./register.vue?vue&type=template&id=74af8ea3&scoped=true", function () {
      api.rerender('74af8ea3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/register.vue"
export default component.exports